<template>

</template>

<script>
export default {
    name: "label"
}
</script>

<style scoped>

</style>